import "./style.scss"
import studentReport from "../../temp_files/studentReport.svg";
import studentPrintable from "../../temp_files/studentPrintable.svg";
import studentPrintableSpanish from "../../temp_files/studentPrintableSpanish.svg";
import schoolOverview from "../../temp_files/schoolOverview.svg";
import Benchmarks from "../../temp_files/Benchmarks.svg";
import schoolPrintable from "../../temp_files/schoolPrintable.svg";
import roster from "../../temp_files/roster.svg";
import districtOverview from "../../temp_files/districtOverview.svg";
import mismatchedCourses from "../../temp_files/mismatchedCourses.svg";
import deficientGrades from "../../temp_files/deficientGrades.svg";
import ReportTab from "../myReports/reportTab";
import React from "react";
import {route as MY_REPORTS_ROUTE} from "../myReports/";

export const route = 'sample-reports';

const sampleReportData =  {
  reports: 0,
    studentReports: [
    {
      id: 'Student-1',
      title: 'Student Report 1',
      thumbnailUrl: studentReport,
      reportEndpoint: 'getSampleStudentReport',
      useCurrentDistrict: false
    },
    {
      id: 'Student-2',
      title: 'Student Report 2',
      thumbnailUrl: studentPrintable,
      pdfReport: true,
      pdfFileName: 'Example_Printer-Friendly_Student_Report.pdf',
      useCurrentDistrict: false
    },
    {
      id: 'Student-3',
      title: 'Student Report 3',
      thumbnailUrl: studentPrintableSpanish,
      pdfReport: true,
      pdfFileName: 'Example_Printer-Friendly_Student_Report_Spanish.pdf',
      useCurrentDistrict: false
    }
  ],
    schoolReports: [
    {
      id: 'School-1',
      title: 'School Report 1',
      thumbnailUrl: schoolOverview,
      reportEndpoint: 'getSampleSchoolOverview',
      useCurrentDistrict: false
    },
    {
      id: 'School-2',
      title: 'School Report 2',
      thumbnailUrl: Benchmarks,
      reportEndpoint: 'getSampleSchoolCourseGPABenchmarks',
      useCurrentDistrict: false
    },
    {
      id: 'School-4',
      title: 'School Report 4',
      thumbnailUrl: roster,
      reportEndpoint: 'getSampleRoster',
      useCurrentDistrict: false
    },
    {
      id: 'School-3',
      title: 'School Report 3',
      thumbnailUrl: schoolPrintable,
      pdfReport: true,
      pdfFileName: 'Example_Printer-Friendly_School_Report.pdf',
      useCurrentDistrict: false
    },
  ],
    districtOverviewReports: [
    {
      id: 'DistrictOverview-1',
      title: 'District Overview',
      thumbnailUrl: districtOverview,
      reportEndpoint: 'getSampleDistrictOverview',
      useCurrentDistrict: false
    }
  ],
  additionalReports: [
    {
      id: 'AdditionalReports-1',
      title: 'Mismatched Courses',
      thumbnailUrl: mismatchedCourses,
      reportEndpoint: 'getSampleMismatchedCourses',
      useCurrentDistrict: false
    },
    {
      id: 'AdditionalReports-2',
      title: 'Deficient Grades',
      thumbnailUrl: deficientGrades,
      reportEndpoint: 'getSampleDeficientGrades',
      useCurrentDistrict: false
    }
  ]
}


const SampleReports = () => {

  const backToMyReports = <div className='sample-back-link'>
    <a href='/#/reports-gallery'>{'<< Back to My Reports'}</a>
  </div>;

  return (
    <div className='reports-container'>
      <ReportTab tabTitle='Sample Reports' studentReports={sampleReportData.studentReports} schoolReports={sampleReportData.schoolReports} districtOverviewReports={sampleReportData.districtOverviewReports} additionalReports={sampleReportData.additionalReports} data={sampleReportData} reportType='Sample' showSampleReports={false} useSchoolCount={false} backToMyReports={backToMyReports} backToLabel='Sample Reports'/>
    </div>
  );
}

export default SampleReports;